import { makeStyles } from 'tss-react/mui';

export default makeStyles()(({ palette }) => ({
  questionItem: {
    color: palette.supporting.blue.main,
  },
}));
